import { useCallback, useContext, useState } from 'react';

import { QualificationContext } from '../../../qualification-context';

const useSegmentDropdown = (initialSegments = []) => {
  const { categories: segmentsOptions } = useContext(QualificationContext);

  const handleInitialSegments = () => {
    const selectedOptions = segmentsOptions.map((item) => {
      const isChecked = initialSegments.includes(item.key);

      return {
        id: item.key,
        label: item.label,
        value: isChecked,
        isValid: item.is_valid,
      };
    });

    return selectedOptions;
  };

  const [segments, setSegments] = useState(() => handleInitialSegments());

  const handleChangeCheckbox = useCallback(
    ({ option }) => {
      const updatedSegments = segments.map((item) => ({
        ...item,
        value: item.id === option,
      }));

      setSegments(updatedSegments);
    },
    [segments]
  );

  return {
    segments,
    handleChangeCheckbox,
  };
};

export default useSegmentDropdown;
